<div class="menu-partial {{classCustom}}" *ngIf="template == 'default'">
    <div class="content" #content>
        <ul>
            <li>
                <a routerLink="/" title="Início" (click)="_navigate('/')">
                    <span>Início</span>
                </a>    
            </li>
            <li>
                <a routerLink="/quem-somos" title="Quem Somos" (click)="_navigate('/quem-somos')">
                    <span>A Lapidace</span>
                </a>    
            </li>
            <li *ngIf="categorias.length == 0">
                <a routerLink="/produtos" title="Produtos" (click)="_navigate('/produtos')">
                    <span>Produtos</span>
                </a>     
            </li> 
            <li *ngIf="categorias.length > 0" class="menu-box home">
                <a routerLink="/produtos" title="Produtos" (click)="_navigate('/produtos')">
                    <span>Produtos</span>
                </a>   
                <div class="menu-box-content">
                    <div class="content-ul">
                        <ul *ngFor="let list of dataCategorias">
                            <li *ngFor="let c of list">
                                <a href="/produtos/{{c.apelido}}" (click)="_navigate('/produtos',c.apelido)" [title]="c.titulo">
                                    <span>{{c.titulo}}</span>
                                </a>     
                            </li>
                        </ul>
                    </div>
                </div>    
            </li> 
            <li class="menu-box home" *ngIf="colecoes.length > 0">
                <a href="javascript::void();" title="Produtos">
                    <span>Coleções</span>   
                </a>  
                <div class="menu-box-content">
                    <div class="content-ul">
                        <ul *ngFor="let list of dataColecoes">
                            <li *ngFor="let c of list">
                                <a href="/produtos/colecao/{{c.apelido}}" (click)="_navigate('/produtos/colecao',c.apelido)" [title]="c.titulo">
                                    <span>{{c.titulo}}</span>
                                </a>    
                            </li>
                        </ul>
                    </div>
                </div>    
            </li>
            <li>
                <a routerLink="/produtos/promocoes" title="Promoções" (click)="_navigate('/produtos/promocoes')">
                    <span>Promoções</span>
                </a>    
            </li>
            <li> 
                <a routerLink="/dicas" title="Dicas" (click)="_navigate('/dicas')">
                    <span>Dicas</span>
                </a>    
            </li>
            <li>
                <a routerLink="/contato" title="Contato" (click)="_navigate('/contato')">
                    <span>Contato</span>
                </a>    
            </li>
            <li>
                <a routerLink="/para-revender" title="Para Revender" (click)="_navigate('/para-revender')">
                    <span>Para Revender</span>
                </a>    
            </li>
        </ul> 
    </div>   
</div>    
<div class="menu-partial {{classCustom}} mobile" *ngIf="template == 'mobile'">
    <button type="button" class="btn-open" (click)="_open()">
        <i class="fa-solid fa-bars"></i>
    </button> 
    <div class="content" #content>
        <ul>
            <li>
                <a routerLink="/" title="Início" (click)="_navigate('/')">
                    <span>Início</span>
                </a>    
            </li>
            <li>
                <a routerLink="/quem-somos" title="Quem Somos" (click)="_navigate('/quem-somos')">
                    <span>Sobre a Lapidace</span>
                </a>    
            </li>
            <li *ngIf="categorias.length == 0">
                <a routerLink="/produtos" title="Produtos" (click)="_navigate('/produtos')">
                    <span>Produtos</span>
                </a>     
            </li> 
            <li *ngIf="categorias.length > 0" class="menu-box home">
                <a href="javascript::void();" title="Produtos" (click)="_showMenu1()">
                    <span>Produtos</span>
                    <i class="fa-solid fa-angle-down"></i> 
                </a>   
                <div class="menu-box-content mobile" [ngClass]="{'show':showMenu1}">
                    <ul>
                        <li *ngFor="let c of categorias">
                            <a href="/produtos/{{c.apelido}}" (click)="_navigate('/produtos',c.apelido)" [title]="c.titulo">
                                <span>{{c.titulo}}</span>
                            </a>     
                        </li>
                    </ul>
                </div>    
            </li> 
            <li class="menu-box" *ngIf="colecoes.length > 0">
                <a href="javascript::void();" title="Produtos" (click)="_showMenu()">
                    <span>Coleções</span>  
                    <i class="fa-solid fa-angle-down"></i>
                </a>  
                <div class="menu-box-content mobile" [ngClass]="{'show':showMenu}">
                    <ul>
                        <li *ngFor="let c of colecoes">
                            <a href="/produtos/colecao/{{c.apelido}}" (click)="_navigate('/produtos/colecao',c.apelido)" [title]="c.titulo">
                                <span>{{c.titulo}}</span>
                            </a>    
                        </li>
                    </ul>
                </div>    
            </li>
            <li>
                <a routerLink="/produtos/promocoes" title="Promoções" (click)="_navigate('/produtos/promocoes')">
                    <span>Promoções</span>
                </a>    
            </li>
            <li> 
                <a routerLink="/produtos/novidades" title="Novidades" (click)="_navigate('/produtos/novidades')">
                    <span>Novidades</span>
                </a>    
            </li>
            <li>
                <a routerLink="/contato" title="Contato" (click)="_navigate('/contato')">
                    <span>Contato</span>
                </a>    
            </li>
            <li>
                <a routerLink="/para-revender" title="Para Revender" (click)="_navigate('/para-revender')">
                    <span>Para Revender</span>
                </a>    
            </li>
        </ul>
    </div> 
</div>
